import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import SearchResults from './SearchResults';
import CarDetail from './CarDetail';
import './styles.css';
import Header from './Components/Header';
import Footer from './Footer';
import TermsOfUse from './Pages/TermsOfUse';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import About from './Pages/About';
import RegisterForm from './UserLogin/RegisterForm';
import LoginForm from './UserLogin/LoginForm';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './AuthContext';
import DealerInventory from './DealerInventory';
import SavedCars from './SavedCars.js';
import SavedSearches from './SavedSearches.js';

function App() {
  return (
     <AuthProvider>
    <Router>
      <ToastContainer position="top-center" autoClose={3000} />
       <Header/>
      <Routes>
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/car/:id" element={<CarDetail />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/dealer/:dealerId" element={<DealerInventory />} />
<Route path="/terms-of-use" element={<TermsOfUse />} />
<Route path="/about" element={<About />} />
<Route path="/saved" element={<SavedCars />} />
<Route path="/savedsearches" element={<SavedSearches />} />

      </Routes>
      <Footer/>
    </Router></AuthProvider>
  );
}

export default App;
